import React from 'react';
import { TranslationView } from '@levelapp/softfabric-ui';
import { Text, View } from 'react-native';
import ProjectQuestion from '../../../../../Common/DTO/ProjectQuestion';
import Helpers from '../../../../../Common/Helpers/AmountHelpers';
import {styles} from "./QuestionsViewStyle";

interface QuestionsViewProps {
    projectQuestions : ProjectQuestion[];
}

export const QuestionsView = ({projectQuestions}:QuestionsViewProps) => {

    if (projectQuestions.length === 0) return null;

    return (
      <View style={styles.page}>
        <TranslationView style={styles.title}>attentionPoints</TranslationView>
        <View style={styles.row}>
          {projectQuestions.map((question: ProjectQuestion, index: number) => {
            return (
              <View key={index} style={[styles.box]}>
                <Text style={styles.boxTitle}>{Helpers.getCorrectTranslation(question.title)}</Text>
                <Text style={styles.boxText}>{Helpers.getCorrectTranslation(question.response)}</Text>
              </View>
            )
          })}
        </View>
      </View>
    );
}

export default QuestionsView;